import { ModelBase } from 'store/model-base';

export class LineDevicePaymentPlan extends ModelBase {
    public static storeName: string = 'lineDevicePaymentPlan';

    public id: Id;
    public total: number;
    public balance: number;
    public paymentAmount: number;
    public paymentTermCompletionDate: Date;
    public paymentTerm: number;
    public finalPaymentAmount: number;
    public paymentsRemaining: number;
    public hasDPP: boolean;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.balance = data.balance ? data.balance : 0;
        data.paymentsRemaining = data.paymentsRemaining ? data.paymentsRemaining : 0;

        return super.create<T>(data);
    }
}
